var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// x-plain-writer-toolbar.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { RXController } from "@adornis/chemistry/controllers/RXController.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/forms/x-input.js";
import "@adornis/forms/x-input.js";
import { html } from "lit";
import { customElement, property, state } from "lit/decorators.js";
import { ref } from "lit/directives/ref.js";
import { repeat } from "lit/directives/repeat.js";
import { fromEvent, of } from "rxjs";
import { switchMap, takeUntil, throttleTime } from "rxjs/operators";
import icons from "./toolbarIcons.js";
import { writerMarker } from "./x-plain-writer.js";
import "./x-writer-drag-handle.js";
import { XWriterState } from "./x-writer-state.js";
var documentCmd = [
  { name: "backColor", desc: "" },
  { name: "bold", desc: "Bold" },
  { name: "ClearAuthenticationCache", desc: "" },
  { name: "contentReadOnly", desc: "" },
  { name: "copy", desc: "" },
  { name: "createLink", desc: "Create Link" },
  { name: "cut", desc: "" },
  { name: "decreaseFontSize", desc: "" },
  { name: "defaultParagraphSeparator", desc: "" },
  { name: "delete", desc: "" },
  { name: "enableAbsolutePositionEditor", desc: "" },
  { name: "enableInlineTableEditing", desc: "" },
  { name: "enableObjectResizing", desc: "" },
  { name: "fontName", desc: "" },
  { name: "fontSize", desc: "" },
  { name: "foreColor", desc: "" },
  { name: "formatBlock", desc: "" },
  { name: "forwardDelete", desc: "" },
  { name: "heading", desc: "" },
  { name: "hiliteColor", desc: "" },
  { name: "increaseFontSize", desc: "" },
  { name: "indent", desc: "" },
  { name: "insertBrOnReturn", desc: "" },
  { name: "insertHorizontalRule", desc: "" },
  { name: "insertHTML", desc: "" },
  { name: "insertImage", desc: "Insert image" },
  { name: "insertOrderedList", desc: "Insert Ordered List" },
  { name: "insertUnorderedList", desc: "Insert Unordered List" },
  { name: "insertParagraph", desc: "" },
  { name: "insertText", desc: "" },
  { name: "italic", desc: "Italic" },
  { name: "justifyCenter", desc: "" },
  { name: "justifyFull", desc: "" },
  { name: "justifyLeft", desc: "" },
  { name: "justifyRight", desc: "" },
  { name: "outdent", desc: "" },
  { name: "paste", desc: "" },
  { name: "redo", desc: "" },
  { name: "removeFormat", desc: "Remove all formatting" },
  { name: "selectAll", desc: "" },
  { name: "strikeThrough", desc: "Strike" },
  { name: "subscript", desc: "Subscript" },
  { name: "superscript", desc: "Superscript" },
  { name: "underline", desc: "Underline" },
  { name: "undo", desc: "" },
  { name: "unlink", desc: "" },
  { name: "useCSS ", desc: "" },
  { name: "styleWithCSS", desc: "" },
  { name: "insertFormula", desc: "Insert Formula" },
  { name: "formatBlockH1", desc: "Make H1" },
  { name: "formatBlockH2", desc: "Make H2" },
  { name: "formatBlockH3", desc: "Make H3" },
  { name: "formatBlockH4", desc: "Make H4" },
  { name: "formatBlockH5", desc: "Make H5" },
  { name: "formatBlockH6", desc: "Make H6" },
  { name: "targetWriter", desc: "Highlight all available writers" }
];
var _a;
var XPlainWriterToolbar = class extends ChemistryLitElement {
  constructor() {
    super();
    this.styles = () => [
      {
        "#container": {
          position: "fixed",
          top: "0px",
          left: "0px",
          opacity: "0",
          transform: "translate(-100px,-100px)",
          transition: "transform 0.3s ease-out, opacity 0.1s linear",
          zIndex: "1000000000000000000",
          svg: { height: "100%" },
          ".stroke": {
            fill: "none",
            stroke: "var(--icon-color, #000)",
            strokeLinecap: "round",
            strokeLinejoin: "round",
            strokeWidth: "2",
            ".thin": {
              strokeWidth: "1"
            },
            ".fill": { fill: "var(--icon-color, #000)" }
          },
          ".fill": { fill: "var(--icon-color, #000)" },
          ".even": { fillRule: "evenodd" }
        }
      }
    ];
    this[_a] = true;
    this.activeWriter = new RXController(this, XWriterState.activeWriter);
    this.attached = new RXController(
      this,
      this.activeWriter.observable.pipe(switchMap((writer) => writer?.["attach-toolbar"].observable ?? of(false)))
    );
    this.inputState = "hidden";
    this.dragHandle = document.createElement("x-writer-drag-handle");
    this.width = 0;
    this.selection = null;
    this.shouldAttach = false;
    if (!XWriterState.toolbarInstance.getValue())
      XWriterState.toolbarInstance.next(this);
    else
      throw new Error("creating two instances of the toolbar is not supported!");
    document.body.appendChild(this.dragHandle);
    XWriterState.writerEvents.subscribe((e) => {
      this.selection = e.detail.selection;
    });
    XWriterState.activeWriter.subscribe((writer) => {
      if (!this._container)
        return;
      if (!writer || !writer.commands?.length)
        return this.hide();
      this.shouldAttach = !!writer["attach-toolbar"].value;
      this.editorBounds = writer.getBoundingClientRect();
      this.width = this._container.getBoundingClientRect().width;
      this.moveToEditor();
    });
  }
  static {
    _a = writerMarker;
  }
  connectedCallback() {
    super.connectedCallback();
    XWriterState.toolbarInstance.next(this);
    fromEvent(document, "mousemove").pipe(throttleTime(100), takeUntil(this.disconnected)).subscribe((e) => this.mouseMoveListener(e));
    fromEvent(document, "mousedown").pipe(throttleTime(100), takeUntil(this.disconnected)).subscribe((e) => this.mouseDownListener(e));
    document.execCommand("defaultParagraphSeparator", false, "p");
  }
  disconnectedCallback() {
    super.disconnectedCallback();
    XWriterState.toolbarInstance.next(void 0);
  }
  render() {
    return html`
      <x-flex id="container" horizontal ${ref((container) => this._container = container)}>
        <div
          id="errorMessage"
          ${css({
      position: "absolute",
      top: "0",
      left: "0",
      padding: "3px 6px",
      color: "var(--a-writer-toolbar-error-color)",
      background: "var(--a-writer-toolbar-error-background)",
      zIndex: "-1",
      fontFamily: "sans-serif",
      opacity: "0",
      transform: "translateX(0)",
      transition: "transform 0.5s ease-out, opacity 0.3s linear"
    })}
        >
          LUL Error goes here!
        </div>
        ${this.inputState === "hidden" ? this.renderToolbar(
      documentCmd.filter((cmd) => (this.activeWriter.value?.commands ?? Object.keys(icons)).includes(cmd.name)),
      this.attached.value
    ) : this.renderInput(this.attached.value)}
      </x-flex>
    `;
  }
  updated(changedProperties) {
    super.updated(changedProperties);
    if (this.inputState === "visible")
      this._input?.focus();
  }
  /**
   * renders the actual toolbar buttons.
   *
   * gets passed an array of commands to render buttons for. These are defined by the writer the toolbar is currently attached to.
   * The corresponding svg template for any command can be fetched by importing `import icons from './toolbarIcons.js';` and then indexing icons with the command `icons[cmd]`
   * To handle any clicks the helper `handleFormat` can be used in a click event listener.
   *
   * Full example:
   * ```ts
   * import icons from './toolbarIcons.js';
   * html`<button @click=${() => this.handleFormat(cmd)}>${icons[cmd]}</button>`
   * ```
   */
  renderToolbar(commands, attached) {
    return html`
      <x-flex flex horizontal space="sm">
        ${repeat(
      commands,
      (cmd) => cmd,
      (cmd) => {
        return html`
              <button style="background: #555; cursor: pointer;" @click=${() => this.handleFormat(cmd.name)}>
                ${icons[cmd.name]}
              </button>
            `;
      }
    )}
      </x-flex>
    `;
  }
  /**
   * renders the embedded input which will be shown if a command requires the user to input some text (like `createLink`)
   * please include an input element derived from `x-input` with the ref directive setting `this._input` so the parent class can read its contents.
   * Also attach the `inputSubmit` and `inputEscape` eventhandler to this input.
   *
   * Full example:
   * ```ts
   * html`
   *  <x-input
   *    ${ref(input => (this._input = input as XInput | undefined))}
   *    .@submit=${(e: ValueEvent<string>) => this.inputSubmit(e)}
   *    .@escape=${(e: Event) => this.inputEscape(e)}
   * ></x-input>
   *`;
   * ```
   */
  renderInput(attached) {
    return html`
      <x-input
        ${ref((input) => this._input = input)}
        id="input"
        @submit=${(e) => this.inputSubmit(e)}
        @escape=${(e) => this.inputEscape(e)}
      ></x-input>
    `;
  }
  handleFormat(cmd) {
    if (cmd === "")
      return;
    if (cmd === "createLink") {
      this.showInput("URL").then((str) => {
        if (str === void 0)
          return;
        document.execCommand(cmd, false, str);
      });
      return;
    }
    if (cmd === "insertImage") {
      document.execCommand("insertHTML", false, `<x-image mode="width" style="width: 300px;" editable></x-image>`);
      return;
    }
    if (cmd === "insertFormula") {
      return;
    }
    if (cmd.startsWith("formatBlock")) {
      const value = cmd.slice(-2).toLocaleLowerCase();
      cmd = "formatBlock";
      const writer = XWriterState.activeWriter.getValue();
      if (writer) {
        document.execCommand(
          cmd,
          false,
          (this.selection?.anchorNode?.nodeType === 3 ? this.selection?.anchorNode?.parentNode?.nodeName : this.selection?.anchorNode?.nodeName) === value.toUpperCase() ? "p" : value
        );
      }
      return;
    }
    if (cmd === "targetWriter")
      return XWriterState.highlight.next(!XWriterState.highlight.getValue());
    document.execCommand(cmd, false);
  }
  inputSubmit(event) {
    this.inputCallback?.(event.detail.value);
    this.hideInput();
    event.preventDefault();
  }
  inputEscape(event) {
    this.inputCallback?.("");
    this.hideInput();
    event.preventDefault();
  }
  showInput(placeholder = "") {
    const ranges = getAllRanges(this.selection);
    return new Promise((resolve) => {
      this.inputCallback = (val) => {
        this.selection.removeAllRanges();
        ranges.forEach((range) => this.selection.addRange(range));
        resolve(val);
      };
      this.inputState = "visible";
    });
  }
  hideInput() {
    this.inputState = "hidden";
  }
  // Move toolbar to given pixel pos
  moveTo(top, left, opacity = 1, lineHeight = 0) {
    let safeLeft = left !== null ? left : this.lastLeft;
    let safeTop = top;
    if ((left || 1) + this.width > window.innerWidth)
      safeLeft = window.innerWidth - this.width;
    if (top < 0 && opacity === 1)
      safeTop = top + lineHeight + 40;
    if (safeTop > window.innerHeight)
      safeTop = 0;
    this.lastLeft = safeLeft;
    const container = this._container;
    container.style.transform = `translate(${safeLeft}px, ${safeTop}px)`;
    container.style.opacity = `${opacity}`;
  }
  // Move toolbar to top of current editor
  moveToEditor() {
    if (!this.editorBounds)
      throw new Error("bounds not initialized");
    if (this.shouldAttach)
      this.attach();
    else
      this.moveTo(this.editorBounds.top - 35, this.editorBounds.left, 1, this.editorBounds.height);
  }
  attach() {
    const writer = XWriterState.activeWriter.getValue();
    if (!writer)
      return;
    writer.renderRoot.querySelector("#toolbarContainer").appendChild(this);
    this._container.style.setProperty("position", "unset");
    this.moveTo(0, 0);
  }
  detach() {
    document.body.appendChild(this);
    this._container.style.setProperty("position", "fixed");
    this._container.style.removeProperty("margin-bottom");
    this.shouldAttach = false;
  }
  hide() {
    if (this.shouldAttach)
      this.detach();
    this.hideInput();
    this.moveTo(-30, null, 0);
  }
  // Generic click listener to hide the toolbar if anything else but an editor or itself is clicked
  mouseDownListener(e) {
    const check = e.composedPath().reduce(
      (acc, elem) => {
        acc.isWriter = acc.isWriter || elem[writerMarker];
        return acc;
      },
      { isWriter: false }
    );
    if (!check.isWriter) {
      XWriterState.activeWriter.next(void 0);
    }
  }
  // Generic click listener to hide the toolbar if anything else but an editor or itself is clicked
  mouseMoveListener(e) {
    if (this.dragHandle.dragging)
      return;
    const check = e.composedPath().reduce(
      (acc, elem) => {
        if (elem.nodeName === "X-IMAGE")
          acc.imgInPath = elem;
        acc.isWriter = acc.isWriter || elem[writerMarker] && !elem.disabled;
        return acc;
      },
      { isWriter: false, imgInPath: null }
    );
    if (check.isWriter && check.imgInPath)
      this.dragHandle.show(check.imgInPath);
  }
};
__decorateClass([
  state()
], XPlainWriterToolbar.prototype, "activeWriter", 2);
__decorateClass([
  state()
], XPlainWriterToolbar.prototype, "attached", 2);
__decorateClass([
  property()
], XPlainWriterToolbar.prototype, "inputState", 2);
XPlainWriterToolbar = __decorateClass([
  customElement("x-plain-writer-toolbar")
], XPlainWriterToolbar);
function getAllRanges(selection) {
  const ranges = [];
  for (let i = 0; i < selection.rangeCount; i++) {
    ranges.push(selection.getRangeAt(i));
  }
  return ranges;
}
export {
  XPlainWriterToolbar,
  documentCmd
};
